import { I18n } from '@calendly/i18n';
import { ProTip } from '@calendly/ui/components/pro-tip';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const scimMessageWrapperCss = "sro7gid";
const ScimMessageWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(scimMessageWrapperCss, props.className)} />;
});
const sectionWrapperCss = "swc3vwb";
const SectionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionWrapperCss, props.className)} />;
});
export const ScimProTip = () => <ScimMessageWrapper>
    <BodyText>{I18n.t('publisher.organization.members.scim.add_members')}</BodyText>
    <ProTip title={I18n.t('publisher.organization.members.scim.pro_tip.heading')}>
      <SectionWrapper>
        <div>
          {I18n.t('publisher.organization.members.scim.empty.description')}
        </div>
        <div>
          {I18n.t('publisher.organization.members.scim.pro_tip.extra_info')}
        </div>
      </SectionWrapper>
    </ProTip>
  </ScimMessageWrapper>;

require("./scim_pro_tip.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./scim_pro_tip.js");